import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SimpleBlockSchema } from '@almanac/contracts';
import { useState } from 'react';
import { z } from 'zod';
import { renderSimpleBlock } from './simple-registry.js';
export const DiagramPropsSchema = z
    .object({
    variant: z.literal('mermaid'),
    title: z.string().optional(),
    code: z.string(),
    fallback_block: SimpleBlockSchema,
})
    .strict();
/**
 * Renders a `diagram` block. v1 does not ship a mermaid rendering engine —
 * this shows a small "diagram" affordance (with the source available on
 * request) and renders `fallback_block` through the shared primitive
 * registry, since `fallback_block` is always a non-recursive `SimpleBlock`.
 */
export function DiagramPrimitive({ title, code, fallback_block, overlay, }) {
    const [showSource, setShowSource] = useState(false);
    return (_jsxs("div", { className: "rounded-lg border border-dashed border-border p-4", children: [_jsxs("div", { className: "mb-2 flex items-center justify-between gap-2", children: [_jsxs("span", { className: "flex items-center gap-1.5 text-xs font-medium text-muted-foreground", children: [_jsx("span", { "aria-hidden": true, children: "\u25C7" }), title ? `Diagram — ${title}` : 'Diagram', _jsx("span", { className: "rounded bg-muted px-1 py-0.5 text-[10px] uppercase tracking-wide text-muted-foreground", children: "mermaid" })] }), _jsx("button", { type: "button", onClick: () => setShowSource((value) => !value), className: "text-xs font-medium text-primary hover:underline", children: showSource ? 'Hide source' : 'View source' })] }), showSource ? (_jsx("pre", { className: "mb-3 overflow-x-auto rounded bg-muted p-2 text-xs text-foreground", children: code })) : null, renderSimpleBlock(fallback_block, overlay)] }));
}
